import { format } from 'date-fns';

import { md5hash } from './Hash'; 

class helperFunctions {

	static sort(object, index, order) {

		try {
			let newArray = [];
			let sorted = order === 'ASC' ? 1 : -1
			if (!object) {
				return newArray;
			}

			if (!Array.isArray(object) && typeof object === 'object') {
				for (let entry in object) {
					newArray.push(object[entry]);
				}
			} else {
				[...newArray] = object;
			}

			if (!newArray.sort) {
				console.warn('Object is not an Array');
				return newArray;
			}

			newArray.sort(function (a, b) {
				if (!a[index] || !b[index]) {
					return null;
				}

				var x = (a[index].toLowerCase && a[index].toLowerCase()) || (a[index]);
				var y = (b[index].toLowerCase && b[index].toLowerCase()) || (b[index]);

				return x < y ? -1 * sorted : x > y ? 1 * sorted : 0;
			});

			// if (order === 'DESC') {
			// 	newArray.reverse();
			// }
			return newArray;

		} catch (err) {
			console.log(err);
		}
	}

	/*	static userHasRightTo(actionName) {
			let userLevel = 1;
			let usersPermissions = {0:['uploadMedia', 'uploadMultipleImages', 'editRestrictedMetadata'], 1:['downloadMedia', 'sendDownloadLinks', 'createProjects', 'createProjectsExtended', 'shareProjects', 'comment', 'fastUpload', 'filterFunction'], 2:['downloadMedia', 'uploadMedia', 'uploadMultipleVideos', 'uploadMultipleImages', 'editRestrictedMetadata', 'createProjects', 'createProjectsExtended', 'comment', 'filterFunction'], 3:['uploadMedia', 'downloadMedia', 'deleteMedia', 'removeFromProject']};
	
			if (usersPermissions[userLevel].indexOf(actionName) !== -1) {
				return true;
			}
	
			return true;
			return false;
		}*/
}

export default helperFunctions;

export const getRandomString = (len, charSet, addCharSet = true) => {
	if (addCharSet) {
		charSet = charSet + 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	} else {
		charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	}

	let randomString = '';
	for (let i = 0; i < len; i++) {
		let randomPoz = Math.floor(Math.random() * charSet.length);
		randomString += charSet.substring(randomPoz, randomPoz + 1);
	}
	return randomString;
}

export const getLocalAndRemoteIds = (allClips, dropedClips = []) => {
	const ids = {
		localIds: [],
		remoteIds: {}
	};

	dropedClips.forEach(dropClip => {
		for (let clip in allClips) {
			if (allClips[clip].id === dropClip) {
				let device = allClips[clip].originalObject.remoteserverdevice;

				if (device) {
					if (!ids.remoteIds.hasOwnProperty(device)) {
						ids.remoteIds[device] = [dropClip];
					} else {
						ids.remoteIds[device].push(dropClip);
					}
				} else {
					ids.localIds.push(dropClip);
				}

				break;
			}
		}
	});

	return ids;
}

export const DATE_FORMAT = "dd.MM.yyyy";

export const dateFormat = (date, dFormat) => {
	try {
		dFormat = dFormat || DATE_FORMAT;
		const theDate = new Date(date);
		const dateString = theDate.toLocaleDateString('de-DE', { 'year': 'numeric', 'month': '2-digit', 'day': '2-digit' });

		if (dateString === 'Invalid Date') {
			return "";
		}
		// NOTE: toUpperCase removed because throws error in format function of date-fns
		// return format(theDate, dFormat.toUpperCase()); 
		return format(theDate, dFormat);
	} catch (e) {
		console.error(e);
		return "";
	}
}

export const getListFromTree = (tree, id, childSelector) => {
    let list = {};
    let childs = {};
    tree.forEach(item => {
        if(item[childSelector]) {
            childs = getListFromTree(item[childSelector], id, childSelector);
        }
		
        list[item[id]] = { ...item };
        list = { ...list, ...childs };
    });
    return list;
}

const MONTH_IN_SEC = 2592000;

const getTimestamp = (ts) => {
    //console.log(new Date(ts * 1000));
    const t = new Date(ts * 1000);
    const d = new Date();
    d.setFullYear(t.getFullYear());
    d.setMonth(t.getMonth());
    d.setDate(t.getDate());
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);
    
    return (d.getTime()/1000);
    //console.log(d.getTime()/1000);
    //console.log(md5hash(d.getTime()/1000));
    //console.log(new Date((d.getTime()/1000)*1000));
}

export const version = (config, data = false) => {
    if(!data) return "";
    
    const start = config._PS_ || 1722146496;
    const build = data.value.pack.unixts;
    const hash = data.value.pack.bt36;
    
    let x = Math.floor((build - start) / MONTH_IN_SEC);
    
    x = x < 10 ? "0"+x : x+"";  
    const min = x.slice(-1);
    const mid = x.slice(0, x.length-1);
    //console.log(x,min,mid);
    const bt36 = getTimestamp(build);
    //console.log(bt36.toString(36));
    
    const v = [ "1", mid, min, bt36.toString(36)/*hash*/ ];
    
    
    return v.join('.');
}
